import {
  formatPhoneDisplay,
  PhoneValidationSchema,
} from '@airship-platform/common/validation';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import SMSOptInConsentModal from '../dialogs/SMSOptInConsentModal';
import { FlexBox } from '../layout';

export const SMSPhoneOptInSchema = z.object({
  phone: PhoneValidationSchema,
  smsOptInConsent: z.boolean(),
});

type SMSPhoneOptInSchemaInputs = z.infer<typeof SMSPhoneOptInSchema>;

const PhoneWithOptInInput: React.FC = () => {
  const [showSMSOptInConsentModal, setShowSMSOptInConsentModal] =
    useState(false);

  const {
    control,
    formState: { errors },
  } = useFormContext<SMSPhoneOptInSchemaInputs>();

  return (
    <FlexBox flexDirection={'column'}>
      <Controller
        name="phone"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            value={formatPhoneDisplay(field.value)}
            type="tel"
            label={'Phone Number'}
            error={!!errors.phone}
            helperText={errors.phone?.message}
            fullWidth
          />
        )}
      />
      <Controller
        name="smsOptInConsent"
        control={control}
        render={({ field }) => (
          <FlexBox
            flexDirection={['column', 'row']}
            alignItems={['flex-start', 'center']}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={field.value}
                  onChange={(event) => field.onChange(event.target.checked)}
                />
              }
              label={
                <Typography variant="body3">
                  I agree to receive SMS messages from Airship
                </Typography>
              }
            />
            <Typography
              variant="body3"
              color="info.dark"
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
                ':hover': {
                  textDecoration: 'none',
                  color: 'info.main',
                },
              }}
              onClick={() => setShowSMSOptInConsentModal(true)}
            >
              Terms of Service
            </Typography>

            <SMSOptInConsentModal
              open={showSMSOptInConsentModal}
              onClose={(consented) => {
                consented && field.onChange(consented);
                setShowSMSOptInConsentModal(false);
              }}
            />
          </FlexBox>
        )}
      />
    </FlexBox>
  );
};

export default PhoneWithOptInInput;
